import api from './api';

const userService = {
  // Get all users (admin only)
  getAllUsers: async () => {
    const response = await api.get('/users/all');
    return response.data;
  },

  // Get user profile
  getUserProfile: async () => {
    const response = await api.get('/users/profile');
    return response.data;
  },

  // Update user role (admin only)
  updateUserRole: async (userId, role) => {
    const response = await api.patch(`/users/${userId}/role`, { role });
    return response.data;
  },

  // Update user status (admin only)
  updateUserStatus: async (userId, isVerified) => {
    const response = await api.patch(`/users/${userId}/status`, { isVerified });
    return response.data;
  },

  // Delete user (admin only)
  deleteUser: async (userId) => {
    const response = await api.delete(`/users/${userId}`);
    return response.data;
  },

  // Update user permissions (admin only)
  updateUserPermissions: async (userId, permissions) => {
    const response = await api.patch(`/users/${userId}/permissions`, { permissions });
    return response.data;
  }
};

export default userService; 